export const validCustomDateRange = (dates) => dates?.length === 2 && dates?.[0] && dates?.[1];
